export default "__VITE_ASSET__a17c99c3__"